/*eslint-disable*/
import {sideChain, authChain, organization, data_table, data_collection, TOKEN_ADDRESS, BRIDGE_ADDRESS} from './Config'
import WeaveHelper from "../../../weaveapi/helper"
import { FilterOp } from "../../../weaveapi/filter";
import { ZKOptions } from "../../../weaveapi/options";
import Web3 from "web3";


const { ethereum } = window;
const Buffer = require("buffer").Buffer

const WeaveBridge_abi = require("./WeaveBridge_abi.json");
const FiatToken_abi = require("./FiatTokenV1_abi.json");

export class Weave  {
    constructor() {
        const storedKeys = localStorage.getItem("keys");
        const hasKeys = storedKeys != null && storedKeys.split(" ").length === 2;
        const keys = hasKeys ? storedKeys.split(" ") : WeaveHelper.generateKeys();
        let publicKey = keys[0];
        let privateKey = keys[1];
        if (!hasKeys) {
            localStorage.setItem("keys", publicKey + " " + privateKey);
        }
        //console.log(publicKey);

        const wallet = localStorage.getItem("wallet");
        const credentials = localStorage.getItem("credentials") ? JSON.parse(localStorage.getItem("credentials")) : null;
        const session = localStorage.getItem("session") ? JSON.parse(localStorage.getItem("session")) : null;

        this.state = {
            wallet: wallet,
            publicKey: publicKey,
            privateKey: privateKey,
            credentials: credentials,
            pageLoadMs: window.performance.timing.navigationStart,
            columns: null,
            data: null,
            averageAge: null,
            dataProof: null,
            session: session
        };
    }

    async getWallet() {
        const accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
        return accounts[0];
    }

    setState(obj) {
        this.state = {...this.state, ...obj};
    }

    async reconnect() {
        localStorage.removeItem("keys");
        localStorage.removeItem("wallet");
        localStorage.removeItem("credentials");
        localStorage.removeItem("session");
        const keys = WeaveHelper.generateKeys();
        let publicKey = keys[0];
        let privateKey = keys[1];
        localStorage.setItem("keys", publicKey + " " + privateKey);

        this.setState({
            publicKey: publicKey,
            privateKey: privateKey,
            wallet: null,
            credentials: null,
            nodeApi: null,
            session: null
        });

        return this.connect();
    }

    async connect() {
        const metaWallet = await this.getWallet();
        if (this.state.wallet === metaWallet) {
            return this.login();
        }

        const pub = this.state.publicKey;
        const pvk = this.state.privateKey;

        const permissions = await ethereum.request({
            method: 'wallet_requestPermissions',
            params: [{
                eth_accounts: {},
            }]
        });
        this.setState({ wallet: metaWallet });
        localStorage.setItem("wallet", this.state.wallet);

        this.setState({ session: localStorage.getItem("session")})

        //This message must match what's hashed on server side, changing it here should trigger changing it also in the node
        let msg = "Please sign this message to confirm you own this wallet\nThere will be no blockchain transaction or any gas fees." +
            "\n\nWallet: " + this.state.wallet +
            "\nKey: " + pub;

        const sig = await ethereum.request({
            method: 'personal_sign',
            params: [ this.state.wallet, msg ]
        });

        const credentials = {
            "account": authChain + ":" + this.state.wallet,
            "sig": sig,
            "template": "*",
            "role": "*"
        }

        localStorage.setItem("credentials", JSON.stringify(credentials));
        this.setState({
            publicKey: pub,
            privateKey: pvk,
            credentials: credentials,
        });

        return this.login();
    }

    async login() {
        const pub = this.state.publicKey;
        const pvk = this.state.privateKey;

        let nodeApi = this.state.nodeApi;
        let session = this.state.session;

        if (nodeApi == null) {
            nodeApi = new WeaveHelper.WeaveAPI().create(WeaveHelper.getConfig(sideChain, pub, pvk));
            await nodeApi.init();
            //console.log(nodeApi)
            const pong = await nodeApi.ping();
            console.log(pong)
            console.log("Public Key", pub);
            console.log(this.state.credentials)

            session = null;
        }

        if (session == null) {
            session = await nodeApi.login(organization, pub, data_collection, this.state.credentials);
            //console.log(session)
            //console.log(session.scopes.length > 0);
            this.setState({"Session": session})
            localStorage.setItem("session", JSON.stringify(this.state.Session));

            this.setState({
                nodeApi,
                session
            })
        }

        return { nodeApi, session };
    }

    async relogin() {
        const pub = this.state.publicKey;
        const pvk = this.state.privateKey;

        let nodeApi = this.state.nodeApi;
        let session = this.state.session;

        if (nodeApi == null) {
            nodeApi = new WeaveHelper.WeaveAPI().create(WeaveHelper.getConfig(sideChain, pub, pvk));
            await nodeApi.init();
            //console.log(nodeApi)
            const pong = await nodeApi.ping();
            console.log(pong)
            console.log("Public Key", pub);
            console.log(this.state.credentials)

            session = null;
        }

        session = await nodeApi.login(organization, pub, data_collection, this.state.credentials);
        //console.log(session)
        //console.log(session.scopes.length > 0);
        this.setState({"Session": session})
        localStorage.setItem("session", JSON.stringify(this.state.Session));

        this.setState({
            nodeApi,
            session
        })

        return session;
    }

    async retry(fn) {
        let { nodeApi, session } = await this.login();

        let res = await fn();
        if (res?.message === "Invalid API key") {
            session = await this.relogin();
            res = await fn();
        }
        return res;
    }

    async write(record) {
        //1. login
        //2. write
        const Records = WeaveHelper.Records;
        const WRITE_DEFAULT = WeaveHelper.Options.WRITE_DEFAULT;

        const records = new Records(data_table, [ record ]);
        let res = await this.retry(() => nodeApi.write(session, data_collection, records, WRITE_DEFAULT))
        console.log("Write result")
        console.log(res)
        return res;
    }

    async writeCode(code) {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. write
        const Records = WeaveHelper.Records;
        const WRITE_DEFAULT_OPTIONS = WeaveHelper.Options.WRITE_DEFAULT;
        const collection = data_collection;
        const table = data_table;

        try {
            return await this.retry(() => eval(code))
        } catch (e) {
            console.log(e);
            return null;
        }
    }

    async computeAvg(field) {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. MPC
        const algo = "mean";
        const fieldsArg = [ field ];
        const filter = new WeaveHelper.Filter(WeaveHelper.FilterOp.gte(field, 0), {"id": "ASC"}, null, null);
        const res = await this.retry(() => nodeApi.mpc(session, data_collection, data_table, algo, fieldsArg, filter, WeaveHelper.Options.MPC_DEFAULT_NO_CHAIN))
        console.log("MPC result")
        console.log(res)
        return res.data;
    }

    async computeCode(code) {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. write
        const Filter = WeaveHelper.Filter;
        const FilterOp = WeaveHelper.FilterOp;
        const MPCOptions = WeaveHelper.Options.MPCOptions;
        const buildMPCOptions = (options, nodes) => new MPCOptions(options.verifyHash, options.readTimeoutSec, nodes);
        const MPC_DEFAULT_OPTIONS = WeaveHelper.Options.MPC_DEFAULT_NO_CHAIN;
        const COMPUTE_DEFAULT_OPTIONS = WeaveHelper.Options.COMPUTE_DEFAULT;
        const collection = data_collection;
        const table = data_table;

        try {
            return await this.retry(() => eval(code))
        } catch (e) {
            console.log(e);
            return null;
        }
    }

    async computeCountsBy(fields) {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. MPC
        const algo = "group_count";
        const filter = null;
        const res = await this.retry(() => nodeApi.mpc(session, data_collection, data_table, algo, fields, filter, WeaveHelper.Options.MPC_DEFAULT_NO_CHAIN))
        console.log("MPC result")
        console.log(res)
        return res.data;
    }

    async computeSumBy(fields) {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. MPC
        const algo = "group_sum";
        const filter = null;
        const res = await this.retry(() => nodeApi.mpc(session, data_collection, data_table, algo, fields, filter, WeaveHelper.Options.MPC_DEFAULT_NO_CHAIN))
        console.log("MPC result")
        console.log(res)
        return res.data;
    }

    async read() {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. read
        //const filter = new WeaveHelper.Filter(null, { "id": "ASC" }, null, null);
        const filter = new WeaveHelper.Filter(null, { "id": "ASC" }, null, [ "email" ]); //collapses based on same Email, getting the latest entry

        //change to WeaveHelper.Options.READ_DEFAULT to check hashes against blockchain (we store hashes on polygon testnet)
        // however, that check will fail if the DB is manually tampered with or the polygon testnet is overloaded.
        // best to keep READ_DEFAULT_NO_CHAIN to have the directory app functioning robustly when people input data
        const options = WeaveHelper.Options.READ_DEFAULT_NO_CHAIN;
        // function to get the hashes stored in the smart contract
        // The
        const h = await this.retry(() => nodeApi.hashes(session, data_collection, data_table, filter, options))
        console.log("Hashes")
        console.log(h)
        const hashes = h.data;

        const res = await nodeApi.read(session, data_collection, data_table, filter, options)
        console.log("Read result")
        console.log(res)

        const data = res.data;
        //console.log(data)

        //3. get the table layout
        const reply = await nodeApi.getTableDefinition(session, data_collection, data_table);
        if (!reply.data) return;
        const def = JSON.parse(reply.data)
        //console.log(def);
        const layout = def.layout;
        console.log("Table layout")
        console.log(layout);

        const columns = layout.columnNames.map((i) => { return { label: i, renderCell: (item) => item[i] }; });
        this.setState({
            columns: columns,
            data: data
        });


        if (data && h.data) {
            data.forEach((it) => it.hash = h.data[it.id]);

            data.forEach((it) => {
                if (!it.hash) {
                    const keys = Object.keys(h.data);
                    for (let j = 0; j < keys.length; j++) {
                        const k = keys[j];
                        if (k.toString().includes("-")) {
                            const rng = k.split("-");
                            if (rng[0].trim() * 1 <= it.id * 1 && rng[1].trim() * 1 >= it.id * 1) {
                                it.hash = h.data[k];
                                break;
                            }
                        }
                    }
                }
            });
        }

        return { data, layout, hashes }
    }

    async download() {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. read
        const format = "csv";
        const filter = new WeaveHelper.Filter(null, { "id": "ASC" }, null, ["email"]);
        const res = await this.retry(() => nodeApi.downloadTable(session, data_collection, data_table, filter, format, WeaveHelper.Options.READ_DEFAULT_NO_CHAIN))
        console.log("Download result")
        console.log(res)

        const fileName = "codiax_attendees";
        const data = new Blob([ Buffer.from(res.data, "base64") ], { type: "application/zip" });
        var url = URL.createObjectURL(data);
        var hlink = document.createElement("a");
        hlink.href = url;
        hlink.download = fileName;
        hlink.click();
    }

    async balance() {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. read balance
        const res = await this.retry(() => nodeApi.balance(session, session.publicKey, "", 'USDC'))
        console.log("Balance")
        console.log(res)
        return res.data;
    }

    async withdraw() {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. read balance
        const res = await this.retry(() => nodeApi.withdraw(session, 'USDC', -1))
        console.log("Withdraw")
        console.log(res)

        if (window.ethereum && !window.web3) {
            window.web3 = new Web3(window.ethereum);
            window.ethereum.enable();
        }

        const tokenContract = await new window.web3.eth.Contract(FiatToken_abi, TOKEN_ADDRESS);
        const decimals = await tokenContract.methods.decimals().call();

        const bridgeContract = await new window.web3.eth.Contract(WeaveBridge_abi, BRIDGE_ADDRESS);
        const acc = await bridgeContract.methods.withdraw(this.state.bridgeBalance * Math.pow(10, decimals)).send({
            from: this.state.currentMetamaskAccount,
            gasPrice: DEFAULT_GAS_PRICE,
            gasLimit: GAS_LIMIT
        });
        console.log(acc);


        return res.data;
    }

    async requestProof(email) {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. generate zk proofs for stored data
        const filter = new WeaveHelper.Filter(FilterOp.eq("email", email), { "id": "DESC" }, 1, null); //retrieve the last inserted value for this email
        const gadgetType = "mimc_string_hash_preimage";
        const fields = [ "phone" ];
        const params = JSON.stringify({});
        const options = new ZKOptions(false, WeaveHelper.Options.DEFAULT_READ_TIMEOUT_SEC, WeaveHelper.Options.ALL_ACTIVE_NODES, 4096, WeaveHelper.Options.DEFAULT_COMMITMENT);
        const res = await this.retry(() => nodeApi.zkProof(session, data_collection, data_table, gadgetType, params, fields, filter, options));
        console.log("ZK Proof result")
        console.log(res)

        const data = res.data;
        console.log("Proof: ", data)

        this.setState({
            dataProof: data
        });
    }

    async verifyProof(email, phone) {
        //1. login
        const { nodeApi, session } = await this.login();

        //2. generate zk proofs for stored data
        const filter = new WeaveHelper.Filter(FilterOp.eq("email", email), { "id": "DESC" }, 1, null); //retrieve the last inserted value for this email
        const gadgetType = "mimc_string_hash_preimage";
        const fields = [ "phone" ];

        //Notes:
        // - this passes the data to the server which hashes it, because we have it implemented only there
        // - we could also call to check just that the hash pre-image is known by passing the hash, but we don't have yet a function to compute this hash in javascript
        //   below is a sample with the hash for "+123456789"
        //   const params = JSON.stringify({ hash: "7TH4N5gBvCPhAY7KLvbPwiceCa1gCpuY1T9SnievwyM2", length: 2 });
        const params = JSON.stringify({ data: phone });
        const res = await this.retry(() => nodeApi.verifyZkProof(session, this.state.dataProof, gadgetType, params, WeaveHelper.Options.DEFAULT_COMMITMENT, 4096));
        console.log("Verify proof result")
        console.log(res)

        const data = res.data;
        console.log("Proof check result: ", data)
    }

}
